import { createStyles } from '@material-ui/core/styles';

export const styles = () =>
  createStyles({
    root: {
      fontSize: 10,
      fill: 'transparent',
    },
  });
